import { useMemo } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { isSimpleUiPack, normalizeUiPack, UI_PACK_CLASSIC } from "@/lib/uiPack";

/** Reads company ui_pack from the authenticated user session. */
export function useUiPack() {
  const { user } = useAuth();
  return useMemo(() => {
    const pack = normalizeUiPack(user?.company?.ui_pack);
    return {
      uiPack: pack,
      isClassic: pack === UI_PACK_CLASSIC,
      isSimple: isSimpleUiPack(pack),
    };
  }, [user?.company?.ui_pack]);
}
